import * as React from 'react';
export const IcSwimming = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21 17a5.67 5.67 0 00-2.66.59 3.82 3.82 0 01-1.84.41 3.84 3.84 0 01-1.85-.41A5.661 5.661 0 0012 17a5.67 5.67 0 00-2.66.59A3.82 3.82 0 017.5 18a3.84 3.84 0 01-1.85-.41A5.59 5.59 0 003 17a1 1 0 000 2 3.82 3.82 0 011.84.41c.826.41 1.739.613 2.66.59a5.66 5.66 0 002.65-.59A3.84 3.84 0 0112 19a3.82 3.82 0 011.84.41c.825.41 1.739.613 2.66.59a5.7 5.7 0 002.66-.59A3.82 3.82 0 0121 19a1 1 0 000-2zM8 7h1.59a2 2 0 011.55.73l1.63 1.89-2.26 1.5A9.07 9.07 0 0112 11a7.641 7.641 0 013.46.76 2 2 0 001 .24 1.84 1.84 0 00.83-.15l-4.62-5.41A4 4 0 009.59 5H8a1 1 0 100 2zm9.5 2a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM3 15a3.82 3.82 0 011.84.41c.826.41 1.739.613 2.66.59a5.66 5.66 0 002.65-.59A3.84 3.84 0 0112 15a3.82 3.82 0 011.84.41c.825.41 1.739.613 2.66.59a5.7 5.7 0 002.66-.59A3.82 3.82 0 0121 15a1 1 0 000-2 5.67 5.67 0 00-2.66.59 3.82 3.82 0 01-1.84.41 3.84 3.84 0 01-1.85-.41A5.661 5.661 0 0012 13a5.67 5.67 0 00-2.66.59A3.82 3.82 0 017.5 14a3.84 3.84 0 01-1.85-.41A5.59 5.59 0 003 13a1 1 0 000 2z'
      fill='currentColor'
    />
  </svg>
);
